import { form } from '../../formState'

import { Notes } from './Notes'
import { Tags } from './Tags'

import { useTexts } from '../useTexts'

export function AdditionalInformation() {
  const texts = useTexts()
  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">
        {texts.getAdditionalInformationTitle}
      </form.SectionTitle>
      <Tags />
      <Notes />
    </form.Fieldset>
  )
}
